import * as React from "react"
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { useController, useFormContext } from "react-hook-form"
import { FormField, Option } from "./types"
import { useCallback } from "react"
import { FormLabel } from "./FormLabel"
import { trackFormEvent } from "./utils"
import cs from "classnames"

import styles from "./Forms.module.scss"

export interface Props extends FormField {
  options: Option[]
  classes?: {
    label?: string
    radioGroup?: string
  }
}

export const Radios = ({ label, disabled, name, rules, options, tracking, classes }: Props) => {
  const { control } = useFormContext()
  const controller = useController({ name, control, rules })

  const error = controller.formState.errors[name]
  const errorProps = error ? { error: error.message?.toString() } : {}

  const handleRadioSelect = useCallback(
    ({ label, value, data, ..._ }: Option) =>
      async () => {
        controller.field.onChange({ label, value, data })

        if (tracking?.shouldTrackValueChange) {
          await trackFormEvent("Form Value Provided", tracking, name, label)
        }
      },
    [controller.field, name, tracking]
  )

  const selectedOption: Option = controller.field.value

  return (
    <FormControl>
      {label && <FormLabel className={classes?.label}>{label}</FormLabel>}
      <RadioGroup name={name} value={selectedOption?.value ?? null} className={classes?.radioGroup}>
        {options.map((o) => (
          <div key={o.value} className={cs(styles.radioWrapper, o.className)}>
            <FormControlLabel
              control={<Radio onChange={handleRadioSelect(o)} size="small" disabled={disabled} />}
              label={o.label}
              value={o.value}
            />

            {o.endAdornment}
          </div>
        ))}
      </RadioGroup>

      {error && <span className={styles.errorLabel}>{errorProps.error}</span>}
    </FormControl>
  )
}

export default Radios
